import React, { useState, createContext, useContext } from 'react';
export type Era = '60s' | '70s' | '80s' | '90s' | '2000s';
interface ThemeContextType {
  currentEra: Era;
  setCurrentEra: (era: Era) => void;
}
const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
export const eraInfo = {
  '60s': {
    title: 'The Underground Press Era',
    description: "The 1960s saw the rise of underground newspapers and mimeographed zines that gave voice to the queer community during a time of severe oppression. Publications like 'The Ladder' by the Daughters of Bilitis provided crucial visibility and connection for lesbian women.",
    className: 'era-60s'
  },
  '70s': {
    title: 'The Liberation Press',
    description: "Following Stonewall, the 1970s witnessed an explosion of gay liberation publications. Newspapers like 'Gay Sunshine' and 'The Furies' combined political activism with cultural expression, creating spaces for emerging queer identities and communities.",
    className: 'era-70s'
  },
  '80s': {
    title: 'Crisis Response Media',
    description: "As AIDS devastated the community, publications like 'OutWeek' and ACT UP's graphic campaigns transformed queer media into tools for survival, combining urgent activism with bold design that demanded attention and action.",
    className: 'era-80s'
  },
  '90s': {
    title: 'Riot Grrrl & Queer Punk',
    description: "The 1990s riot grrrl and queer punk movements embraced DIY zine culture, with raw, photocopied publications like 'BIMBOX' and 'Chainsaw' creating radical spaces for intersectional queer and feminist voices.",
    className: 'era-90s'
  },
  '2000s': {
    title: 'Digital Transition',
    description: "The early 2000s marked queer publishing's shift to digital formats, with blogs and early social platforms enabling global connection. Sites like AfterEllen and Pam's House Blend combined the DIY ethos of zines with the reach of the internet.",
    className: 'era-2000s'
  }
};
export const ThemeProvider: React.FC<{
  children: ReactNode;
}> = ({
  children
}) => {
  const [currentEra, setCurrentEra] = useState<Era>('90s');
  return <ThemeContext.Provider value={{
    currentEra,
    setCurrentEra
  }} data-id="element-403">
      {children}
    </ThemeContext.Provider>;
};
export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};